import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PostCard from "../components/PostCard";

function Details() {
  const { id } = useParams();
  const { data } = useSelector((state) => state.posts);

  // find selected post
  const post = data.find((p) => p.id === Number(id));

  if (!post) return <p>Post not found</p>;

  return (
    <div className="detail">

      {/* MAIN POST SECTION */}
      <div className="detail-top">
        <img
          src={`https://picsum.photos/400?random=${post.id}`}
          alt=""
        />

        <div className="detail-content">
          <h2>Post Number #{post.id}</h2>
          <h3>{post.title}</h3>
          <p>{post.body}</p>
          <p><strong>User ID:</strong> {post.userId}</p>
        </div>
      </div>

      {/* MORE POSTS */}
      <h2 className="more-title">More Posts</h2>

      <div className="grid">
        {data
          .filter((p) => p.id !== post.id) // exclude current post
          .slice(0, 6)
          .map((p) => (
            <PostCard key={p.id} post={p} />
          ))}
      </div>

    </div>
  );
}

export default Details;